module.exports = __webpack_public_path__ + "img/navIco.d8881a90.png";